import usersTasksService from '@/services/usersTasksService'
import { convertTZ, getDate, getDateFullTime } from '@/libs/changeTimeZones'

const state = {
  selectedUserTask: {},
  totalUserTasks: 0,
  userTasks: [],
  userTasksNotifications: [],
  taskPagination: {},
  totalPendingTasks: 0,
  withoutResponsibleTasksNotifications: [],
  withoutResponsibleTasksTotal: 0,
  taskOutcomes: []
}

const mutations = {
  'SET_SELECTED_USER_TASK' (state, selectedUserTask) {
    state.selectedUserTask = selectedUserTask
  },
  'SET_TASKS_ROW' (state, taskInfo) {
    const { rowIndex, task } = taskInfo
    state.userTasks[rowIndex] = task
  },
  'SET_TOTAL_USER_TASKS' (state, totalUserTasks) {
    state.totalUserTasks = totalUserTasks
  },
  'SET_USER_TASKS' (state, userTasks) {
    state.userTasks = userTasks
  },
  'SET_USER_TASKS_NOTIFICATIONS' (state, userTasksNotifications) {
    state.userTasksNotifications = userTasksNotifications
  },
  'SET_TASK_OUTCOMES' (state, taskOutcomes) {
    state.taskOutcomes = taskOutcomes
  },
  'SET_TASK_PAGINATION' (state, taskPagination) {
    state.taskPagination = taskPagination
  },
  'SET_TOTAL_PENDING_TASKS' (state, totalPendingTask) {
    state.totalPendingTasks = totalPendingTask
  },
  'SET_WITHOUT_RESPONSIBLE_TASKS_NOTIFICATIONS' (state, withoutResponsibleTasksNotifications) {
    state.withoutResponsibleTasksNotifications = withoutResponsibleTasksNotifications
  },
  'SET_WITHOUT_RESPONSIBLE_TASKS_TOTAL' (state, withoutResponsibleTasksTotal) {
    state.withoutResponsibleTasksTotal = withoutResponsibleTasksTotal
  }
}

const actions = {
  async deleteUserTask (vuexContext, { companyId, appId, userId, taskId }) {
    const company = companyId || vuexContext.getters.companyUuid
    const app = appId || vuexContext.getters.appUuid
    await usersTasksService.deleteTask(
      vuexContext.getters.token,
      company,
      app,
      userId,
      taskId
    )
    return true
  },
  async getTaskOutcomes ({ commit, getters }) {
    try {
      const response = await usersTasksService.getTaskOutcomes(getters.token)
      commit('SET_TASK_OUTCOMES', response)
    } catch (e) {
      commit('SET_TASK_OUTCOMES', [])
    }
  },
  async getUserTasks (vuexContext, { companyId, appId, userId }) {
    try {
      const company = companyId || vuexContext.getters.companyUuid
      const app = appId || vuexContext.getters.appUuid
      const response = await usersTasksService.getTasks(
        vuexContext.getters.token,
        company,
        app,
        userId
      )
      vuexContext.commit('SET_USER_TASKS', response.tasks.rows)
      vuexContext.commit('SET_TOTAL_USER_TASKS', response.tasks.count)
      return true
    } catch (e) {
      vuexContext.commit('SET_USER_TASKS', [])
      vuexContext.commit('SET_TOTAL_USER_TASKS', 0)
      throw e
    }
  },
  async getUserTask (vuexContext, { companyId, appId, userId, taskId }) {
    try {
      const company = companyId || vuexContext.getters.companyUuid
      const app = appId || vuexContext.getters.appUuid
      const response = await usersTasksService.getTask(
        vuexContext.getters.token,
        company,
        app,
        userId,
        taskId
      )
      vuexContext.commit('SET_SELECTED_USER_TASK', response)
      return true
    } catch (e) {
      vuexContext.commit('SET_SELECTED_USER_TASK', {})
      throw e
    }
  },
  async newUserTask (vuexContext, { companyId, appId, userId, data }) {
    const company = companyId || vuexContext.getters.companyUuid
    const app = appId || vuexContext.getters.appUuid
    await usersTasksService.newTask(
      vuexContext.getters.token,
      company,
      app,
      userId,
      data
    )
    return true
  },
  async updateUserTask (vuexContext, { companyId, appId, userId, task }) {
    const company = companyId || vuexContext.getters.companyUuid
    const app = appId || vuexContext.getters.appUuid
    await usersTasksService.updateTask(
      vuexContext.getters.token,
      company,
      app,
      userId,
      task
    )
    return true
  },
  async getTasksNotifications (vuexContext) {
    try {
      const app = vuexContext.getters.appUuid
      const response = await usersTasksService.getTasksNotifications(
        vuexContext.getters.token,
        app,
        vuexContext.state.taskPagination
      )
      vuexContext.commit('SET_USER_TASKS_NOTIFICATIONS', response.currentTask)
      vuexContext.commit('SET_TOTAL_PENDING_TASKS', response.taskTotal)
      vuexContext.commit('SET_WITHOUT_RESPONSIBLE_TASKS_NOTIFICATIONS', response.withoutResponsibleTasks)
      vuexContext.commit('SET_WITHOUT_RESPONSIBLE_TASKS_TOTAL', response.withoutResponsibleTasksCount)
      return true
    } catch (e) {
      vuexContext.commit('SET_USER_TASKS_NOTIFICATIONS', [])
      throw e
    }
  }
}

const addShortDateAndTime = (tasks, timezone) => {
  tasks.forEach(item => {
    const date = convertTZ(item.date, timezone)
    item.shortDate = getDate(date)
    item.time = getDateFullTime(date)
    item.date = date
  })
  return tasks
}

const getters = {
  userTasks (state, getters, rootState) {
    const userTasks = JSON.parse(JSON.stringify(state.userTasks))
    return addShortDateAndTime(userTasks, rootState.auth.userKeybeTimeZone.label)
  },
  userTasksNotifications (state, getters, rootState) {
    const userTasks = JSON.parse(JSON.stringify(state.userTasksNotifications))
    return addShortDateAndTime(userTasks, rootState.auth.userKeybeTimeZone.label)
  },
  withoutResponsibleTasksNotifications (state, getters, rootState) {
    const userTasks = JSON.parse(JSON.stringify(state.withoutResponsibleTasksNotifications))
    return addShortDateAndTime(userTasks, rootState.auth.userKeybeTimeZone.label)
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
